import { TypographyProps, Typography } from '@mui/material';
import { useField } from 'formik';

export const TypographyField = (props: { name: string } & TypographyProps) => {
  const { name, ...rest } = props;
  const [field, meta, helpers] = useField(name);
  return <Typography {...rest}>{field.value}</Typography>;
};
